import {Event} from "typescript.events";
import {decorate, injectable} from "inversify";

decorate(injectable(), Event);

@injectable()
export class EventEmitter extends Event
{ }